/* eslint-disable no-loop-func */
import React, { useState, useEffect } from "react";
import Highcharts from "highcharts/highstock";
import exporting from "highcharts/modules/exporting.js";
import moment from "moment";
import HighchartsReact from "highcharts-react-official";
import { Form, Modal, ListGroup } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import {
  getStockData,
  getRealData,
} from "../../actions/home.actions.polygon";
import { isEmpty } from "../../helpers/import-constant";
import { options, shiftPos } from "../../helpers/app-constants";
import styles from "./Home.module.css";

exporting(Highcharts);
require("highcharts/modules/annotations")(Highcharts);

export default function HomePloygon(props) {
  const dispatch = useDispatch();
  const [stockDatas, SetStockDatas] = useState([]);
  const [stockLoad, SetStockLoad] = useState(false);
  const [showModal, SetShowModal] = useState(false);
  const [showTradeModal, SetShowTradeModal] = useState(false);
  const [showOptionTradeModal, SetOptionTradeModal] = useState(false);
  const [opetionTrade ] = useState("Complete");
  const [storeSymb, SetStoreSymb] = useState([]);
  const [tradeTitle ] = useState("");
  const [tickerInput, SetTickerInput] = useState("");
  const [stockNote, SetStockNote] = useState("");
  const [currentPrice, SetCurrentPrice] = useState("");
  const [currentVol, SetCurrentVol] = useState("");
  const [stockOption, SetStockOption] = useState(true);
  const [stockHold, SetStockHold] = useState(true);
  const [stockSymb, SetStockSymb] = useState("AAPL");
  const [stockDate, SetStockDate] = useState("");
  const [dateToExpiration, SetdateToExpiration] = useState("");
  const [dateTradeCompleated, SetdateTradeCompleated] = useState("");
  const [premiumReceived, SetpremiumReceived] = useState("");
  const [callOrPut, SetcallOrPut] = useState("Call");
  const [dateTradeInitiated, SetdateTradeInitiated] = useState("");
  const [stockQty, SetStockQty] = useState("");
  const [debitOrCost, SetdebitOrCost] = useState("");
  const [strikePrice, SetstrikePrice] = useState("");
  const [apiError, SetApiError] = useState(false);
  const [stockRate, SetStockRate] = useState("");
  const [boughtOrSold, SetboughtOrSold] = useState("green");
  const [stockHoldDate, SetStockHoldDate] = useState("");
  const [numberOfContracts, SetnumberOfContracts] = useState("");
  const [userTradeInfo, setUserTradeInfo] = useState([]);
 
  const [shape, setShape] = useState([]);
  const [annotationList, setAnnotationList] = useState([]);
  const [label, setLabel] = useState([]);
  const [annotateClose ] = useState(Date.now());
  const { stockData, realData } = useSelector(
    (state) => {
      return state.Home;
    }
  );

  (function (H) {
    H.Annotation.prototype.onDrag = function (e) {
      if (
        this.chart.isInsidePlot(
          e.chartX - this.chart.plotLeft,
          e.chartY - this.chart.plotTop
        )
      ) {
        var translation = this.mouseMoveToTranslation(e),
          yAxis = this.chart.yAxis[0],
          step = 50,
          pxStep = yAxis.toPixels(0) - yAxis.toPixels(step);

        if (!H.defined(this.potentialTranslation)) {
          this.potentialTranslation = 0;
        }

        this.potentialTranslation += translation.y;

        if (Math.abs(this.potentialTranslation) >= pxStep) {
          translation.y = this.potentialTranslation > 0 ? pxStep : -pxStep;
          translation.x = 0;
          this.potentialTranslation -=
            this.potentialTranslation > 0 ? pxStep : -pxStep;

          if (this.points.length) {
            this.translate(translation.x, translation.y);
          } else {
            this.shapes.forEach(function (shape) {
              shape.translate(translation.x, translation.y);
            });
            this.labels.forEach(function (label) {
              label.translate(translation.x, translation.y);
            });
          }
        }

        this.redraw(false);
      }
    };
  })(Highcharts);

  /*save data to storage*/
  const saveData = () => {
    SetShowModal(false);
    saveToStorage(stockSymb);
    getLocalSymbollist();
  };

  const saveTradeData = () => {
    SetShowTradeModal(false);
    let tradeArray = JSON.parse(localStorage.getItem("tradeInfo"));
    let tradeTemp = [];

    if (tradeArray !== null) {
      tradeTemp = [...tradeArray];
      const syl = [];
      for (var ii = 0; ii < tradeArray.length; ii++) {
        syl.push(tradeArray[ii].symbol);
      }
      tradeTemp.push({
        title: opetionTrade,
        symbol: stockSymb,
        stockPurchase: stockOption,
        buyDate: stockDate,
        qty: stockQty,
        price: stockRate,
        stockHold: stockHold,
        dateTradeCompleated: stockHoldDate === "" ? "" : stockHoldDate,
        sockType: "stock-trade",
      });
    } else {
      tradeTemp.push({
        title: tradeTitle,
        symbol: stockSymb,
        stockPurchase: stockOption,
        buyDate: stockDate,
        qty: stockQty,
        price: stockRate,
        stockHold: stockHold,
        dateTradeCompleated: stockHoldDate === "" ? "" : stockHoldDate,
        sockType: "stock-trade",
      });
    }

    localStorage.setItem("tradeInfo", JSON.stringify(tradeTemp));

    showStockData(stockSymb);
  };

  const saveOptionTradeData = () => {
    SetOptionTradeModal(false);
    let tradeArray = JSON.parse(localStorage.getItem("tradeInfo"));

    let tradeTemp = [];

    if (tradeArray !== null) {
      tradeTemp = [...tradeArray];
      const syl = [];
      for (var ii = 0; ii < tradeArray.length; ii++) {
        syl.push(tradeArray[ii].symbol);
      }
      tradeTemp.push({
        symbol: stockSymb,
        title: opetionTrade,
        buyDate: dateTradeInitiated,
        dateToExpiration: dateToExpiration,
        price: strikePrice,
        callOrPut: callOrPut,
        qty: numberOfContracts,
        boughtOrSold: boughtOrSold,
        dateTradeCompleated: dateTradeCompleated,
        premiumReceived: premiumReceived,
        debitOrCost: debitOrCost,
        sockType: "option-trade",
      });
    } else {
      tradeTemp.push({
        symbol: stockSymb,
        title: opetionTrade,
        buyDate: dateTradeInitiated,
        dateToExpiration: dateToExpiration,
        price: strikePrice,
        callOrPut: callOrPut,
        qty: numberOfContracts,
        boughtOrSold: boughtOrSold,
        dateTradeCompleated: dateTradeCompleated,
        premiumReceived: premiumReceived,
        debitOrCost: debitOrCost,
        sockType: "option-trade",
      });
    }
    localStorage.setItem("tradeInfo", JSON.stringify(tradeTemp));

    showStockData(stockSymb);
  };

  const saveToStorage = (symb) => {
    let commentsArray = JSON.parse(localStorage.getItem("symbollist"));
    let temp = [];
    if (commentsArray !== null) {
      temp = [...commentsArray];
      if (!commentsArray.includes(symb)) {
        temp.unshift(symb);
      }
    } else {
      temp.unshift(symb);
    }
    showStockData(symb);
    localStorage.setItem("symbollist", JSON.stringify(temp));
    SetTickerInput("");
  };

  const showStockData = (s) => {
    dispatch(getStockData(s));
    dispatch(getRealData(s));
    SetStockSymb(s);
    getLocalTradeInfo(s);

    shiftPos(storeSymb, s);
  };

  /*fetchapi using redux*/
  useEffect(() => {
    dispatch(getStockData(stockSymb));
    dispatch(getRealData(stockSymb));
    getLocalSymbollist();
    getLocalTradeInfo(stockSymb);
  }, [dispatch]);

  const getLocalSymbollist = () => {
    if (JSON.parse(localStorage.getItem("symbollist"))) {
      let t = [];
      JSON.parse(localStorage.getItem("symbollist")).map((item) => {
        t.push(item);
        return null
      });
      SetStoreSymb(t);
    }
  };

  const getLocalTradeInfo = (t) => {
    const trade = JSON.parse(localStorage.getItem("tradeInfo"));

    if (trade) {
      let [tr, s, l, a] = [[], [], [], []];
      for (var ii = 0; ii < trade.length; ii++) {
        if (trade[ii].symbol === t) {
          tr.push(trade[ii]);
          const date1 = new Date(trade[ii].buyDate);
          const timestamp = date1.getTime();
          let callorputTemp = "";
          let pandlVlaue = 0;

          if (trade[ii].callOrPut === "Call") {
            callorputTemp = "C";
          } else {
            callorputTemp = "P";
          }

          let plValue = 0;
          if (trade[ii].boughtOrSold === "red") {
            plValue = 'collected: $'+trade[ii].debitOrCost;
            callorputTemp += "-BTC";
            pandlVlaue = 'YTD: $'+trade[ii].qty * 100 * trade[ii].debitOrCost;
          } else {
            plValue = 'collected: $'+trade[ii].premiumReceived;
            callorputTemp += "-STO";
            pandlVlaue = 'YTD: $'+trade[ii].qty * 100 * trade[ii].premiumReceived;
          }

          if (typeof plValue === "undefined") {
            plValue = 0;
          }

          if (typeof trade[ii].dateToExpiration === "undefined") {
            trade[ii].dateToExpiration = 0;
          }

          if (!pandlVlaue) {
            pandlVlaue = 0;
          }

          l = [
            {
              backgroundColor: "rgba(0, 0, 0, 0.70)",
              borderWidth: 0,
              point: {
                x: timestamp,
                y: trade[ii].price,
                xAxis: 0,
                yAxis: 0,
              },
              text: trade[ii].boughtOrSold === "red" ? "+" + trade[ii].qty + " | " + moment(timestamp).format("ll") + " (" + trade[ii].dateToExpiration + "d) <br/> " + trade[ii].price + " " + callorputTemp + " | " + plValue + "| P&L - " + pandlVlaue : "-" + trade[ii].qty + " | " + moment(timestamp).format("ll") + " (" + trade[ii].dateToExpiration + "d) <br/> " + trade[ii].price + " | " + callorputTemp + " | " + plValue + "| P&L - " + pandlVlaue,
               
            },
            {
              align: 'left',
              borderwidth: 1,
              backgroundColor: 'rgba(00, 100, 00, 0.8)',
              // backgroundColor:
              //   trade[ii].boughtOrSold === "red" ? "#308030" : "#b03030",
              // borderWidth: 0,
              point: {
                x: timestamp,
                y: 690,
                xAxis: 0,
                yAxis: 0,
              },
               text: plValue + "| <br>P/L - " + pandlVlaue,
              // text: "collected: +$0.82 <br>P/L YTD: $680",
            },
          ];

          s = {
            fill: "none",
            stroke:
              trade[ii].boughtOrSold === "red"
                ? "green"
                : "rgba(200, 0, 0, 0.50)",
            dashStyle:
              trade[ii].sockType === "stock-trade" ? "solid" : "ShortDot",
            strokeWidth: trade[ii].sockType === "stock-trade" ? 6 : 4,
            type: "path",
            points: [
              {
                x: timestamp,
                y: trade[ii].price,
                xAxis: 0,
                yAxis: 0,
              },
              {
                x:
                  trade[ii].dateTradeCompleated === ""
                    ? annotateClose
                    : new Date(trade[ii].dateTradeCompleated),
                y: trade[ii].price,
                xAxis: 0,
                yAxis: 0,
              },
            ],
          };

          a.push({
            draggable: "y",
            shapes: s,
            labels: l,
          });
        }
      }

      setAnnotationList(a);
      setShape(s);
      setLabel(l);
      setUserTradeInfo(tr);
    }
  };

  useEffect(() => {
    if (stockData.error || realData.error) {
      SetApiError(true);
      SetStockNote(
        "You've exceeded the maximum requests per minute, please wait 1 minute or upgrade your subscription to continue."
      );
    }
    if (!isEmpty(stockData)) {
      const items = stockData.results;
      if (!isEmpty(items)) {
        const stockArray = [];
        stockData.results &&
          stockData.results.map(({ c, t }) => stockArray.push([t, c]));

        SetStockDatas(stockArray);
        SetStockLoad(true);
      }
    }
  }, [stockData]);

  useEffect(() => {
    if (!isEmpty(realData) || realData.queryCount > 0) {
      let Rate = 0;
      let Vol = 0;
      if (realData.results) {
        realData.results.forEach((item, index) => {
          Vol = item.v;
          Rate = item.c;
        });
      }

      SetCurrentPrice(parseFloat(Rate));
      let columeTemp = Vol.toString().replace(
        /\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g,
        ","
      );
      SetCurrentVol(columeTemp);
    }
  }, [realData]);

  const opt = options(
    stockSymb,
    stockDatas,
    annotateClose,
    annotationList,
    shape,
    label
  );

  return (
    <div className="">
      <div className={styles.header_wrap}>
        <div className={styles.ticker_box}>
          <h4 className={styles.ticker_symb}>{stockSymb}</h4>
          <h2 className={styles.ticker_price}>{currentPrice}</h2>
          <h6 className={styles.ticker_vol}>Vol: {currentVol}</h6>
        </div>
        <div className={styles.ticker_in}>
          <input
            type="text"
            className={styles.ticker_input}
            onChange={(e) => {
              SetStockSymb(e.target.value.toUpperCase());
              SetTickerInput(e.target.value.toUpperCase());
            }}
            value={tickerInput}
            placeholder="ticker"
          />
          <button className={styles.ticker_go} onClick={() => saveData()}>
            GO
          </button>

          <button
            className={styles.btn}
            onClick={() => SetShowTradeModal(true)}
          >
            Add Stock Trade
          </button>
          <button
            className={styles.btn}
            onClick={() => SetOptionTradeModal(true)}
          >
            Add Options Trade
          </button>
        </div>
      </div>

      {showTradeModal && (
        <Modal show={showTradeModal} onHide={() => SetShowTradeModal(false)}>
          {/* <Modal.Header className={styles.modal} closeButton>
          </Modal.Header> */}
          <Modal.Body className={styles.modal}>
            <Form>
              <div className={styles.ticker_modal}>{stockSymb}</div>
              <div>
                <button
                  type="button"
                  onClick={() => SetShowTradeModal(false)}
                  className={styles.close_button}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <Form.Group controlId="formBasicSelect">
                <Form.Label className={styles.label_font}>
                  Stock Purchased:
                </Form.Label>
                <div className="row">
                  <div className="col-md-2">
                    <Form.Check
                      type="radio"
                      label="Yes"
                      name="stockBuy"
                      id="radio1"
                      className={styles.radio_font}
                      defaultChecked
                      onChange={(e) => SetStockOption(true)}
                    />
                  </div>
                  <div className="col-md-2">
                    <Form.Check
                      type="radio"
                      label="No"
                      name="stockBuy"
                      id="radio2"
                      className={styles.radio_font}
                      onChange={(e) => SetStockOption(false)}
                    />
                  </div>
                </div>
              </Form.Group>

              {stockOption && (
                <>
                  <Form.Group controlId="duedate">
                    <Form.Control
                      type="date"
                      name="duedate"
                      placeholder="Due date"
                      className={styles.input}
                      // value={date}
                      onChange={(e) => SetStockDate(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group controlId="duedate">
                    <Form.Control
                      type="number"
                      name="qty"
                      className={styles.input}
                      placeholder="Enter Qty"
                      onChange={(e) => SetStockQty(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Control
                      type="number"
                      className={styles.input}
                      onChange={(e) => SetStockRate(e.target.value)}
                      placeholder="Stock Price"
                    />
                  </Form.Group>
                  <Form.Group controlId="formBasicSelect">
                    <Form.Label className={styles.label_font}>
                      Still Holding:
                    </Form.Label>
                    <div className="row">
                      <div className="col-md-2">
                        <Form.Check
                          type="radio"
                          label="Yes"
                          className={styles.radio_font}
                          name="stockHold"
                          id="radio1"
                          defaultChecked={stockHold === true ? true : false}
                          onChange={(e) => SetStockHold(true)}
                        />
                      </div>
                      <div className="col-md-2">
                        <Form.Check
                          type="radio"
                          className={styles.radio_font}
                          label="No"
                          name="stockHold"
                          id="radio2"
                          defaultChecked={stockHold === false ? true : false}
                          onChange={(e) => SetStockHold(false)}
                        />
                      </div>
                      {stockHold === false && (
                        <Form.Group
                          className="mb-3"
                          controlId="formBasicPassword"
                        >
                          <Form.Control
                            type="date"
                            className={styles.input}
                            onChange={(e) => SetStockHoldDate(e.target.value)}
                            placeholder="Stock Price"
                          />
                        </Form.Group>
                      )}
                    </div>
                  </Form.Group>
                </>
              )}

              <Form.Group controlId="duedate">
                <button
                  className={styles.button}
                  onClick={() => saveTradeData()}
                >
                  Submit
                </button>
              </Form.Group>
            </Form>
          </Modal.Body>
        </Modal>
      )}

      {showModal && (
        <Modal
          show={showModal}
          className={styles.modal}
          onHide={() => SetShowModal(false)}
        >
          <Modal.Header closeButton>
            <h5>Add Stock Symbol Information:</h5>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Stock Symbol</Form.Label>
                <Form.Control
                  type="text"
                  onChange={(e) => SetStockSymb(e.target.value)}
                  placeholder="Enter Stock Symbol"
                />
              </Form.Group>

              <Form.Group controlId="duedate">
                <button className="mt-4" onClick={() => saveData()}>
                  Submit
                </button>
              </Form.Group>
            </Form>
          </Modal.Body>
        </Modal>
      )}

      {stockLoad && (
        <div className={styles.main_body}>
          {apiError === true ? (
            <h4>{stockNote}</h4>
          ) : (
            <>
              <div className={styles.ticker_history_div}>
                <ListGroup>
                  {storeSymb && storeSymb.length ? (
                    storeSymb.map(function (val, index, array) {
                      return (
                        <ListGroup.Item
                          className={styles.ticker_history_item}
                          class="list-group-item"
                          role="button"
                          onClick={() => showStockData(val)}
                          key={val}
                        >
                          {val}
                        </ListGroup.Item>
                      );
                    })
                  ) : (
                    <ListGroup.Item>No Symbol:</ListGroup.Item>
                  )}
                </ListGroup>
              </div>
              <div className={styles.chart_container}>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={opt}
                  constructorType={"stockChart"}
                />
              </div>
              <div className="row ml-3 mt-4">
                <p>
                  {userTradeInfo && userTradeInfo.length ? (
                    userTradeInfo.map(function (i, k) {
                      return (
                        <>
                          <span>
                            {k + 1}. Title: {i.title}
                          </span>{" "}
                          | <span>Symbol: {i.symbol}</span> |{" "}
                          <span>
                            Stock Purchase: {i.stockPurchase ? "Yes" : "No"}
                          </span>
                          | <span>Purchase Date: {i.buyDate}</span> |{" "}
                          <span>Qty: {i.qty}</span> |{" "}
                          <span>Price: {i.price}</span> |{" "}
                          <span>Hold Status: {i.stockHold ? "Yes" : "No"}</span>
                          <br />
                        </>
                      );
                    })
                  ) : (
                    <span>No Trade Info has been added yet:</span>
                  )}
                </p>
              </div>
            </>
          )}
        </div>
      )}
      {showOptionTradeModal && (
        <Modal
          show={showOptionTradeModal}
          onHide={() => SetOptionTradeModal(false)}
        >
          {/* <Modal.Header closeButton className={styles.modal}>
            <h5>Add Option Trade Information:</h5>
          </Modal.Header> */}
          <Modal.Body className={styles.modal}>
            <Form>
              {opetionTrade === "Active" && (
                <>
                  <Form.Group className="mb-3" controlId="dateTradeInitiated">
                    <Form.Label>Date Trade Initiated</Form.Label>
                    <Form.Control
                      type="date"
                      name="dateTradeInitiated"
                      placeholder="Date Trade Initiated"
                      onChange={(e) => SetdateTradeInitiated(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="dateToExpiration">
                    <Form.Label>Days To Expiration</Form.Label>
                    <Form.Control
                      type="number"
                      name="dateToExpiration"
                      placeholder="Days To Expiration"
                      onChange={(e) => SetdateToExpiration(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group controlId="strikePrice">
                    <Form.Label>Strike Price</Form.Label>
                    <Form.Control
                      type="number"
                      name="strikePrice"
                      placeholder="Strike Price"
                      onChange={(e) => SetstrikePrice(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="callOrPut">
                    <Form.Label>Call / Put</Form.Label>
                    <Form.Control
                      as="select"
                      value={callOrPut}
                      onChange={(e) => {
                        SetcallOrPut(e.target.value);
                      }}
                    >
                      <option value="0" disabled>
                        Select Option
                      </option>
                      <option value="Call">Call</option>
                      <option value="Put">Put</option>
                    </Form.Control>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="numberOfContracts">
                    <Form.Label>Number Of Contracts</Form.Label>
                    <Form.Control
                      type="number"
                      name="numberOfContracts"
                      placeholder="Number Of Contracts"
                      onChange={(e) => SetnumberOfContracts(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="boughtOrSold">
                    <Form.Label>Bought / Sold</Form.Label>
                    <Form.Control
                      as="select"
                      value={boughtOrSold}
                      onChange={(e) => {
                        SetboughtOrSold(e.target.value);
                      }}
                    >
                      <option value="0" disabled>
                        Select Option
                      </option>
                      <option value="green">Bought</option>
                      <option value="red">Sold</option>
                    </Form.Control>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="debitOrCost">
                    <Form.Label>Debit/ Cost (negative number)</Form.Label>
                    <Form.Control
                      type="number"
                      name="debitOrCost"
                      placeholder="Debit/ Cost (negative number)"
                      onChange={(e) => SetdebitOrCost(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="premiumReceived">
                    <Form.Label>Premium Received (positive number)</Form.Label>
                    <Form.Control
                      type="number"
                      name="premiumReceived"
                      placeholder="Premium Received (positive number)"
                      onChange={(e) => SetpremiumReceived(e.target.value)}
                    />
                  </Form.Group>
                </>
              )}

              {opetionTrade === "Complete" && (
                <>
                  <div className={styles.ticker_modal}>{stockSymb}</div>
                  <div>
                    <button
                      type="button"
                      onClick={() => SetOptionTradeModal(false)}
                      className={styles.close_button}
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <Form.Group className="mb-3" controlId="dateTradeInitiated">
                    <Form.Control
                      type="date"
                      name="dateTradeInitiated"
                      className={styles.input}
                      placeholder="Date Trade Initiated"
                      onChange={(e) => SetdateTradeInitiated(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="dateTradeCompleated">
                    <Form.Control
                      type="date"
                      name="dateTradeCompleated"
                      placeholder="Date Trade Compleated"
                      className={styles.input}
                      max={moment().format("YYYY-MM-DD")}
                      onChange={(e) => SetdateTradeCompleated(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="dateToExpiration">
                    <Form.Control
                      type="number"
                      name="dateToExpiration"
                      className={styles.input}
                      placeholder="Days To Expiration"
                      onChange={(e) => SetdateToExpiration(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group controlId="strikePrice">
                    <Form.Control
                      type="number"
                      name="strikePrice"
                      className={styles.input}
                      placeholder="Strike Price"
                      onChange={(e) => SetstrikePrice(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="callOrPut">
                    <Form.Control
                      as="select"
                      className={styles.ticker_select}
                      value={callOrPut}
                      onChange={(e) => {
                        SetcallOrPut(e.target.value);
                      }}
                    >
                      <option value="0" disabled>
                        Select Option
                      </option>
                      <option value="Call">Call</option>
                      <option value="Put">Put</option>
                    </Form.Control>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="numberOfContracts">
                    <Form.Control
                      type="number"
                      className={styles.input}
                      name="numberOfContracts"
                      placeholder="Number Of Contracts"
                      onChange={(e) => SetnumberOfContracts(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="boughtOrSold">
                    <Form.Control
                      as="select"
                      value={boughtOrSold}
                      className={styles.ticker_select}
                      onChange={(e) => {
                        SetboughtOrSold(e.target.value);
                      }}
                    >
                      <option value="0" disabled>
                        Select Option
                      </option>
                      <option value="green">Bought</option>
                      <option value="red">Sold</option>
                    </Form.Control>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="debitOrCost">
                    <Form.Control
                      type="number"
                      className={styles.input}
                      name="debitOrCost"
                      placeholder="Debit/ Cost (negative number)"
                      onChange={(e) => SetdebitOrCost(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="premiumReceived">
                    <Form.Control
                      type="number"
                      className={styles.input}
                      name="premiumReceived"
                      placeholder="Premium Received (positive number)"
                      onChange={(e) => SetpremiumReceived(e.target.value)}
                    />
                  </Form.Group>
                </>
              )}
              <Form.Group controlId="duedate">
                <button
                  className={styles.button}
                  onClick={() => saveOptionTradeData()}
                >
                  Submit
                </button>
              </Form.Group>
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
}
